import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export type { DatePickerSize } from './date-picker.types';

export const DatePicker = withSuspense(lazy(() => import('./date-picker.component')));
